/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Offer.module.scss";
import Inputs from "../../Inputs";
import { useForm, Controller } from "react-hook-form";
import { connect } from "react-redux";
import { listAgencies, getCurrentOffer, deleteOffer, editOffer } from "../../../actions/offer";
import { getCurrentTicket } from "../../../actions/tickets";
import moment from "moment";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { calculateMonetary } from "../../../utils/helperFunctions";
import {
  convertCurrency,
  formatMoney,
  getBaseCurrencyBySwitchDate,
  getCurrencySymbol,
  getDisplayCurrencyOrderBySwitchDate,
} from "../../../utils/currency";
import { API_URL } from "../../../config/settings";

const customStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#0083E5", // Custom colour
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#0083E5" : "white",
    padding: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: (window.innerWidth / 100) * 18,
    height: 40,
    display: "flex",
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition };
  },
};

const customStylesHigher = {
  dropdownIndicator: (base, state) => ({
    ...base,
    color: "#0083E5", // Custom colour
    transition: "all .2s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  option: (provided, state) => ({
    ...provided,
    borderBottom: "1px dotted pink",
    color: state.isSelected ? "white" : "black",
    backgroundColor: state.isSelected ? "#0083E5" : "white",
    padding: 10,
  }),
  valueContainer: (base) => ({
    ...base,
    overflowY: "scroll",
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: (window.innerWidth / 100) * 21,
    display: "flex",
    height: 70,
    border: "1px solid rgb(165, 164, 164)",
    borderRadius: "7px",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition };
  },
};

const instalPairs = [
  {
    key: "installmentOneDate",
    labelKey: "offers:installmentNDue", n: 1,
    sumKey: "installmentOneSum",
  },
  {
    key: "installmentTwoDate",
    labelKey: "offers:installmentNDue", n: 2,
    sumKey: "installmentTwoSum",
  },
  {
    key: "installmentThreeDate",
    labelKey: "offers:installmentNDue", n: 3,
    sumKey: "installmentThreeSum",
  },
  {
    key: "installmentFourDate",
    labelKey: "offers:installmentNDue", n: 4,
    sumKey: "installmentFourSum",
  },
];

const liquidationOptions = ["Официален сервиз", "Доверен сервиз", "Експертна оценка"];
const viewOptions = ["Да", "Не"];
const additionalSecurityOptions = ["Да", "Не"];
const premiumInfoOptions = [
  "Всички суми са с включен данък.",
  "Застрахователните премии са крайни, с включени отстъпки.",
  "В качеството си на 'Специален потребител', на мобилното приложение Амарант в офертата е калкулирана и допълнителна преференциална отстъпка за Вас",
  "Застрахователните премии са валидни до промяна в тарифата на застрахователя или рисковите обстоятелства",
];

const EditOffer = ({ listAgencies, agencies, getCurrentOffer, deleteOffer, editOffer, getCurrentTicket, currentTicket, currentOffer }) => {
  const { t } = useTranslation();
  const [instCount, setInstCount] = useState(1);
  const ticketID = window.location.href.split("/")[4];
  const offerID = window.location.href.split("/")[5];
  const [fullDiscount, setFullDiscount] = useState({
    type: null,
    percent: null,
    discount: null,
    byCompany: null,
  });
  const navigate = useNavigate();

  const {
    register,
    control,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    startDate: "",
    installmentsCount: 1,
    installmentOneDate: "",
    installmentTwoDate: null,
    installmentThreeDate: null,
    installmentFourDate: null,
    insuranceCompanyName: "",
    insuranceCompanyId: "",
    insuranceSum: null,
    premium: null,
    installmentOneSum: null,
    installmentTwoSum: null,
    installmentThreeSum: null,
    installmentFourSum: null,
    documents: "",
    generalConditions: "",
    additionalInfo: "",
    liquidation: "",
    view: "",
    security: "",
    premiumInfo: [],
  });

  useEffect(() => {
    listAgencies();
    getCurrentOffer({
      id: offerID,
      onSuccess: (res) => {
        console.log("[Offer][edit] getCurrentOffer response", {
          offerId: res?._id,
          hasBgn: Boolean(res?.bgn),
          insuranceSum: res?.insuranceSum,
          premium: res?.premium,
          originalPremium: res?.originalPremium,
          installmentOneSum: res?.installmentOneSum,
          installmentTwoSum: res?.installmentTwoSum,
          installmentThreeSum: res?.installmentThreeSum,
          installmentFourSum: res?.installmentFourSum,
          bgnInsuranceSum: res?.bgn?.insuranceSum,
          bgnPremium: res?.bgn?.premium,
        });
        const offerAmounts = res;
        const discountMatch = res?.discountInfo?.match(/\d+/g);
        const parsedDiscount = discountMatch?.[0] ? Number(discountMatch[0]) : 0;
        setFullDiscount({
          byCompany: res?.ticket?.promoData?.discountCampaign?.customDiscounts?.filter((disc) => res?.ticket?.promoData?.policyType === disc?.policyType)?.[0]?.customDiscountsPerInsuranceAgency,
          type: res?.ticket?.promoData?.policyType,
          percent: res?.ticket?.promoData?.discountCampaign?.discountInPercent,
          discount: Number.isFinite(parsedDiscount) ? parsedDiscount : 0,
        });
        setValue("startDate", moment(res.startDate.split("T")[0])._d);
        setValue("installmentsCount", res?.installmentsCount);
        setInstCount(res?.installmentsCount);
        setValue("installmentOneDate", moment(res?.installmentOneDate.split("T")[0])._d);
        setValue("installmentTwoDate", res?.installmentTwoDate ? moment(res?.installmentTwoDate.split("T")[0])._d : null);
        setValue("installmentThreeDate", res?.installmentThreeDate ? moment(res?.installmentThreeDate.split("T")[0])._d : null);
        setValue("installmentFourDate", res?.installmentFourDate ? moment(res?.installmentFourDate.split("T")[0])._d : null);
        setValue("insuranceCompanyName", res?.insuranceCompanyName);
        setValue("insuranceCompanyId", res?.insuranceCompanyId);
        setValue("insuranceSum", offerAmounts?.insuranceSum);
        setValue("premium", offerAmounts?.premium);
        setValue("originalPremium", offerAmounts?.originalPremium);
        setValue("installmentOneSum", offerAmounts?.installmentOneSum);
        setValue("installmentTwoSum", offerAmounts?.installmentTwoSum || null);
        setValue("installmentThreeSum", offerAmounts?.installmentThreeSum || null);
        setValue("installmentFourSum", offerAmounts?.installmentFourSum || null);
        setValue("documents", res?.documents[0]);
        setValue("generalConditions", res?.generalConditions[0]);
        setValue("liquidation", res?.liquidation);
        setValue("view", res?.view);
        setValue("security", res?.security);
        setValue(
          "premiumInfo",
          res?.premiumInfo?.map((info) => {
            return {
              label: info,
              value: info,
            };
          })
        );
        setValue("additionalInfo", res?.additionalInfo);
      },
    });
  }, []);

  const calculatePercentDiscount = (premium, discount) => {
    if (discount > 0 && premium) {
      const formula = premium - ((premium / 1.02) * discount) / 100;
      // const VAT = 0.02;
      // const discountMultiplier = 1 - discount / 100;
      // const discountableAmount = calculateMonetary(e - e * VAT);
      // const discountedPremium = calculateMonetary(discountableAmount * discountMultiplier);
      return calculateMonetary(formula);
    } else return premium;
  };

  const handleOfferWithoutDiscount = (e) => {
    const payload = {
      offerID: offerID,
      payload: {
        startDate: moment(e.startDate).format("YYYY-MM-DD"),
        installmentsCount: e.installmentsCount,
        installmentOneDate: moment(e.installmentOneDate).format("YYYY-MM-DD"),
        installmentTwoDate: e.installmentTwoDate ? moment(e.installmentTwoDate).format("YYYY-MM-DD") : undefined,
        installmentThreeDate: e.installmentThreeDate ? moment(e.installmentThreeDate).format("YYYY-MM-DD") : undefined,
        installmentFourDate: e.installmentFourDate ? moment(e.installmentFourDate).format("YYYY-MM-DD") : undefined,
        insuranceCompanyName: e.insuranceCompanyName,
        insuranceCompanyId: e.insuranceCompanyId,
        insuranceSum: Number(e.insuranceSum),
        premium: Number(e.premium),
        installmentOneSum: Number(e.installmentOneSum),
        installmentTwoSum: Number(e.installmentTwoSum),
        installmentThreeSum: Number(e.installmentThreeSum),
        installmentFourSum: Number(e.installmentFourSum),
        documents: [e.documents],
        generalConditions: [e.generalConditions],
        additionalInfo: e.additionalInfo,
        liquidation: e?.liquidation,
        view: e?.view,
        security: e?.security,
        premiumInfo: e?.premiumInfo.map((info) => info.value),
        onSuccess: (res) => {
          toast.success(t("app:offerEdited"));
          navigate(-1);
        },
      },
    };
    // console.log(payload);
    console.log("[Offer][edit] payload (no discount)", {
      offerId: payload?.offerID,
      installmentsCount: payload?.payload?.installmentsCount,
      insuranceSum: payload?.payload?.insuranceSum,
      premium: payload?.payload?.premium,
      originalPremium: payload?.payload?.originalPremium,
    });
    editOffer(payload);
  };

  const handleOfferWithDiscount = (e) => {
    const discountedAmount = fullDiscount.percent ? calculatePercentDiscount(e?.originalPremium, fullDiscount.discount) : e?.originalPremium - fullDiscount.discount;
    const payload = {
      offerID: offerID,
      payload: {
        startDate: moment(e.startDate).format("YYYY-MM-DD"),
        installmentsCount: e.installmentsCount,
        installmentOneDate: moment(e.installmentOneDate).format("YYYY-MM-DD"),
        installmentTwoDate: e.installmentTwoDate ? moment(e.installmentTwoDate).format("YYYY-MM-DD") : undefined,
        installmentThreeDate: e.installmentThreeDate ? moment(e.installmentThreeDate).format("YYYY-MM-DD") : undefined,
        installmentFourDate: e.installmentFourDate ? moment(e.installmentFourDate).format("YYYY-MM-DD") : undefined,
        insuranceCompanyName: e.insuranceCompanyName,
        insuranceCompanyId: e.insuranceCompanyId,
        insuranceSum: Number(e.insuranceSum),
        originalPremium: Number(e.originalPremium),
        installmentOneSum: +(discountedAmount / instCount).toFixed(2),
        installmentTwoSum: instCount >= 2 ? +(discountedAmount / instCount).toFixed(2) : Number(e.installmentTwoSum),
        installmentThreeSum: instCount >= 3 ? +(discountedAmount / instCount).toFixed(2) : Number(e.installmentThreeSum),
        installmentFourSum: instCount === 4 ? +(discountedAmount / instCount).toFixed(2) : Number(e.installmentFourSum),
        documents: [e.documents],
        generalConditions: [e.generalConditions],
        additionalInfo: e.additionalInfo,
        liquidation: e?.liquidation,
        view: e?.view,
        security: e?.security,
        premium: Number(discountedAmount),
        discountInfo: fullDiscount?.percent
          ? `-${fullDiscount.discount}%`
          : `-${fullDiscount.discount} ${getCurrencySymbol(offerBaseCurrency)}`,
        premiumInfo: e?.premiumInfo.map((info) => info.value),
        onSuccess: (res) => {
          toast.success(t("app:offerEdited"));
          navigate(-1);
        },
      },
    };
    const installmentsSum = payload.payload?.installmentOneSum + payload.payload?.installmentTwoSum + payload.payload?.installmentThreeSum + payload.payload?.installmentFourSum;
    if (installmentsSum < payload.payload.premium) payload.payload.installmentOneSum += payload.payload.premium - installmentsSum;

    // console.log(payload);
    console.log("[Offer][edit] payload (with discount)", {
      offerId: payload?.offerID,
      installmentsCount: payload?.payload?.installmentsCount,
      insuranceSum: payload?.payload?.insuranceSum,
      premium: payload?.payload?.premium,
      originalPremium: payload?.payload?.originalPremium,
      discountInfo: payload?.payload?.discountInfo,
    });
    editOffer(payload);
  };

  const discountNum = Number(fullDiscount.discount);
  const hasDiscount = discountNum > 0;
  const discounted = hasDiscount
    ? calculatePercentDiscount(watch(`originalPremium`), discountNum)
    : watch(`originalPremium`);
  const safeInstCount = Number(instCount) || 1;
  const safeDiscountNum = Number.isFinite(discountNum) ? discountNum : 0;

  const now = new Date();
  const isProdApi = API_URL?.includes("cs-api.fidweb.net");
  const offerBaseCurrency = currentOffer?.bgn
    ? "EUR"
    : isProdApi
    ? getBaseCurrencyBySwitchDate(now)
    : "EUR";
  const offerDisplayOrder = currentOffer?.bgn
    ? ["EUR", "BGN"]
    : isProdApi
    ? getDisplayCurrencyOrderBySwitchDate(now)
    : ["EUR", "BGN"];
  const getSecondaryHint = (amount) => {
    const secondaryCurrency = offerDisplayOrder[1];
    const converted = convertCurrency(amount, offerBaseCurrency, secondaryCurrency);
    if (converted === null) return undefined;
    return `≈ ${formatMoney(converted)} ${getCurrencySymbol(secondaryCurrency)}`;
  };

  return (
    <div className={styles["amarant-container"]}>
      <div className={styles["upper-info-container"]}>
        <h2 className={styles["title"]}>{t("offers:editOffer")}</h2>
        <div
          style={{
            display: "flex",
            width: "15%",
          }}
        >
          <Inputs.Button
            text={t("delete")}
            className="delete"
            style={{ marginRight: "3%", width: "130px" }}
            onClick={handleSubmit((e) => {
              deleteOffer({
                id: offerID,
                onSuccess: () => {
                  toast.success(t("app:offerDeleted"));
                  navigate(-1);
                },
              });
            })}
          />
          <Inputs.Button
            text={t("save")}
            className="green"
            style={{ marginRight: "1%", width: "130px" }}
            onClick={handleSubmit((e) => {
              if (!currentOffer?.originalPremium) handleOfferWithoutDiscount(e);
              else handleOfferWithDiscount(e);
            })}
          />
        </div>
      </div>
      <div className={styles["middle-info-container"]}>
        <h2 className={styles["title"]}>{t("offers:mainParams")}</h2>
        <div className={styles["main-parameters-container"]}>
          <Controller
            control={control}
            name={"startDate"}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Inputs.DatePicker
                label={t("offers:startDate")}
                compulsory
                custom
                style={{ width: "12%", height: "100%" }}
                value={value}
                onChange={(e) => {
                  setValue("startDate", e);
                }}
                className={error && "failed"}
              />
            )}
            rules={{ required: true }}
          />
          <Controller
            control={control}
            name={"installmentsCount"}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <div style={{ margin: "0% 3%" }}>
                <label>{t("offers:installmentCount")}</label>
                <div style={{ display: "flex" }}>
                  <Inputs.Button
                    text={1}
                    selected={value === 1}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      setValue("installmentsCount", 1);
                      setInstCount(1);
                    }}
                  />
                  <Inputs.Button
                    text={2}
                    selected={value === 2}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      setValue("installmentsCount", 2);
                      setValue(instalPairs[2].key, undefined);
                      setValue(instalPairs[2].sumKey, null);
                      setValue(instalPairs[3].key, undefined);
                      setValue(instalPairs[3].sumKey, null);
                      setInstCount(2);
                    }}
                  />
                  <Inputs.Button
                    text={3}
                    selected={value === 3}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      setValue("installmentsCount", 3);
                      setValue(instalPairs[3].key, undefined);
                      setValue(instalPairs[3].sumKey, null);
                      setInstCount(3);
                    }}
                  />
                  <Inputs.Button
                    text={4}
                    selected={value === 4}
                    style={{ marginRight: "3%" }}
                    onClick={() => {
                      setValue("installmentsCount", 4);
                      setInstCount(4);
                    }}
                  />
                </div>
              </div>
            )}
            rules={{ required: true }}
          />
          {Array(instCount)
            .fill("")
            .map((el, i) => {
              return (
                <Controller
                  control={control}
                  key={i}
                  name={instalPairs[i].key}
                  render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <Inputs.DatePicker
                      label={t(instalPairs[i].labelKey, { n: instalPairs[i].n })}
                      compulsory
                      custom
                      style={{ width: "12%", height: "100%", margin: "0% 2%" }}
                      value={value}
                      onChange={(e) => {
                        setValue(instalPairs[i].key, e);
                      }}
                      className={error && "failed"}
                    />
                  )}
                  rules={{ required: true }}
                />
              );
            })}
          <div className="input-container" style={{ width: "5%" }}>
            <label style={{ display: "flex", width: "100%", fontSize: "0.8rem", marginBottom: "5px" }}>{t("offers:discount")}</label>
            <p style={{ marginTop: "10px", color: currentTicket?.promoData && "#01D088" }}>{currentTicket?.promoData ? t("yes") : t("no")}</p>
          </div>
        </div>
      </div>
      <div className={styles["lower-info-container"]}>
        <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
          <h2 className={styles["title"]}>{t("offers:offer1")}</h2>
        </div>
        <div>
          <div className={styles["main-parameters-container"]}>
            <Controller
              control={control}
              name={`insuranceCompanyName`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Inputs.Dropdown
                  label={t("offers:insuranceCompany")}
                  optionsArray={agencies?.map((agency) => {
                    return {
                      label: agency?.name,
                      value: agency?._id,
                    };
                  })}
                  compulsory
                  edit={true}
                  value={value}
                  customStyles={customStyles}
                  style={{ width: "fit-content", height: "100%" }}
                  single
                  className={error && "failed"}
                  onChange={(e) => {
                    setValue(`insuranceCompanyName`, e.label);
                    setValue(`insuranceCompanyId`, e.value);
                    if (fullDiscount.byCompany)
                      setFullDiscount((prevState) => {
                        return {
                          ...prevState,
                          discount: prevState.byCompany?.filter((comp) => comp?.insuranceAgency === e.value)?.[0]?.discount,
                        };
                      });
                  }}
                />
              )}
              rules={{ required: true }}
            />

            <Inputs.TextInput label={t("offers:insuranceSum")} suffix={getCurrencySymbol(offerBaseCurrency)} style={{ width: "150px", marginRight: "1%" }} className={errors?.insuranceSum ? "failed" : ""} {...register(`insuranceSum`)} />
            {!currentOffer?.originalPremium ? (
              <Controller
                control={control}
                name={`premium`}
                render={({ field: { value, onChange }, fieldState: { error } }) => <Inputs.TextInput label={t("offers:premium")} compulsory suffix={getCurrencySymbol(offerBaseCurrency)} value={value} type="number" style={{ width: "150px", marginRight: "1%" }} className={errors.offers?.[i]?.premium ? "failed" : ""} onChange={(e) => setValue(`premium`, Number(e.target.value))} />}
                rules={{ required: true }}
              />
            ) : (
              <>
                <Controller
                  control={control}
                  name={`originalPremium`}
                  render={({ field: { value, onChange }, fieldState: { error } }) => (
                    <>
                      <Inputs.TextInput
                        label={t("offers:premium")}
                        compulsory
                        suffix={getCurrencySymbol(offerBaseCurrency)}
                        type="text"
                        pattern="^\\d+(\\.\\d{0,2})?$"
                        value={value}
                        style={{ width: "150px", marginRight: "1%" }}
                        className={errors.offers?.[i]?.originalPremium ? "failed" : ""}
                        onChange={(e) => setValue(`originalPremium`, e.target.value)}
                      />
                      <Inputs.TextInput
                        label={t("offers:discount")}
                        compulsory
                        suffix={"%"}
                        type="number"
                        value={Number.isFinite(safeDiscountNum) ? safeDiscountNum : 0}
                        style={{ width: "100px", marginRight: "1%" }}
                        onFocus={() => {
                          if (fullDiscount.discount) {
                            setFullDiscount((prev) => ({ ...prev, discount: '' }));
                          }
                        }}
                        onChange={(e) => {
                          let val = e.target.value.replace(/^0+(?=\d)/, '');
                          setFullDiscount((prev) => ({ ...prev, discount: Number(val), percent: true }));
                        }}
                      />
                      <Inputs.TextInput
                        label={t("offers:premiumWithDiscount")}
                        suffix={getCurrencySymbol(offerBaseCurrency)}
                        value={
                          value && !isNaN(Number(value))
                            ? (hasDiscount && discounted && !isNaN(discounted)
                                ? Number(discounted).toFixed(2)
                                : Number(value).toFixed(2))
                            : ""
                        }
                        disabled
                        style={{ width: "150px", marginRight: "1%" }}
                      />
                      {Array(instCount)
                        .fill("")
                        .map((el, j) => (
                          <Inputs.TextInput
                            label={t("offers:installmentN", { n: j + 1 })}
                            compulsory
                            disabled={true}
                            key={j + 1}
                            value={(() => {
                              const originalPremiumNum = Number(value);
                              const discountedNum = Number(discounted);
                              const base = hasDiscount
                                ? discountedNum
                                : originalPremiumNum - safeDiscountNum;
                              if (!Number.isFinite(base) || !Number.isFinite(safeInstCount)) return "";
                              return +((base / safeInstCount).toFixed(2));
                            })()}
                            suffix={getCurrencySymbol(offerBaseCurrency)}
                            style={{ width: "150px", marginRight: "1%" }}
                          />
                        ))}
                    </>
                  )}
                  rules={{ required: true }}
                />
              </>
            )}

            {!currentOffer?.originalPremium &&
              Array(instCount)
                .fill("")
                .map((el, j) => {
                  return (
                    <Inputs.TextInput
                      label={t("offers:installmentN", { n: j + 1 })}
                      compulsory
                      key={j + 1}
                      suffix={getCurrencySymbol(offerBaseCurrency)}
                      style={{ width: "150px", marginRight: "1%" }}
                      className={errors.offers?.[i]?.[instalPairs[j].sumKey] ? "failed" : ""}
                      type="text"
                      pattern="^\\d+(\\.\\d{0,2})?$"
                      value={watch(`${instalPairs[j].sumKey}`) ?? ""}
                      onChange={(e) => {
                        let val = e.target.value.replace(',', '.');
                        setValue(`${instalPairs[j].sumKey}`, val);
                      }}
                      {...register(`${instalPairs[j].sumKey}`, {
                        required: true,
                        pattern: { value: /^\d+(\.\d{0,2})?$/, message: t("offers:invalidAmount") },
                      })}
                    />
                  );
                })}
          </div>
          <div className={styles["main-parameters-container-files"]}>
            <Controller
              control={control}
              name={`documents`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <>
                  <Inputs.ImageInput
                    label={t("offers:infoDocument")}
                    compulsory
                    style={{ width: "420px", margin: "10px 0px" }}
                    value={value}
                    specialDir={true}
                    info={{
                      keyword: "offer",
                      id: ticketID,
                      date: moment().format("DD.MM.YYYY"),
                    }}
                    key={"documents"}
                    onChange={(e) => setValue(`documents`, e)}
                    setValue={setValue}
                    className={error && "failed"}
                  />
                </>
              )}
              rules={{ required: true }}
            />
            <Controller
              control={control}
              name={`generalConditions`}
              render={({ field: { value, onChange }, fieldState: { error } }) => <Inputs.ImageInput label={t("offers:generalTerms")} compulsory style={{ width: "420px", margin: "10px 0px" }} value={value} onChange={(e) => setValue(`generalConditions`, e)} setValue={setValue} className={error && "failed"} />}
              rules={{ required: true }}
            />
          </div>
          <div className={styles["main-parameters-container"]}>
            <Controller
              control={control}
              name={`liquidation`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Inputs.Dropdown
                  label={t("offers:liquidationType")}
                  optionsArray={liquidationOptions?.map((liq) => {
                    return {
                      label: liq,
                      value: liq,
                    };
                  })}
                  customStyles={customStyles}
                  style={{ width: "23%", height: "100%" }}
                  single
                  edit
                  value={value}
                  className={error && "failed"}
                  onChange={(e) => {
                    setValue(`liquidation`, e.value);
                  }}
                />
              )}
            />
            <Controller
              control={control}
              name={`view`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Inputs.Dropdown
                  label={t("offers:inspectionRequired")}
                  optionsArray={viewOptions?.map((view) => {
                    return {
                      label: view,
                      value: view,
                    };
                  })}
                  customStyles={customStyles}
                  style={{ width: "23%", height: "100%" }}
                  single
                  edit
                  value={value}
                  onChange={(e) => {
                    setValue(`view`, e.value);
                  }}
                />
              )}
            />
            <Controller
              control={control}
              name={`security`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Inputs.Dropdown
                  label={t("offers:additionalSecurity")}
                  optionsArray={additionalSecurityOptions?.map((opt) => {
                    return {
                      label: opt,
                      value: opt,
                    };
                  })}
                  customStyles={customStyles}
                  style={{ width: "23%", height: "100%" }}
                  single
                  edit
                  value={value}
                  onChange={(e) => {
                    setValue(`security`, e.value);
                  }}
                />
              )}
            />
            <Controller
              control={control}
              name={`premiumInfo`}
              render={({ field: { value, onChange }, fieldState: { error } }) => (
                <Inputs.Dropdown
                  label={t("offers:premium")}
                  optionsArray={premiumInfoOptions?.map((opt) => {
                    return {
                      label: opt,
                      value: opt,
                    };
                  })}
                  customStyles={customStylesHigher}
                  style={{ width: "23%", height: "100%" }}
                  value={value}
                  edit
                  onChange={(e) => {
                    setValue(`premiumInfo`, e);
                  }}
                />
              )}
            />
          </div>
          <Inputs.TextInput
            label={t("offers:additionalOfferInfo")}
            compulsory
            style={{ width: "100%" }}
            className={errors.additionalInfo ? "failed" : ""}
            {...register(`additionalInfo`, {
              required: true,
            })}
          />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  agencies: state.offer.agencies,
  currentTicket: state.tickets.currentTicket,
  currentOffer: state.offer.currentOffer,
});
const mapDispatchToProps = (dispatch) => ({
  listAgencies: (payload) => dispatch(listAgencies(payload)),
  getCurrentOffer: (payload) => dispatch(getCurrentOffer(payload)),
  deleteOffer: (payload) => dispatch(deleteOffer(payload)),
  editOffer: (payload) => dispatch(editOffer(payload)),
  getCurrentTicket: (payload) => dispatch(getCurrentTicket(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EditOffer);
